import React from 'react';
import { useSelector } from 'react-redux';
import TabLayout from '../shared/TabLayout';
import { selectSelectedReport } from '../../redux/store/userData/reports';
import ReportInfo from './ReportInfo';
import styles from './ReportDrawerBody.styles';

const ReportDrawerBody: React.FC = () => {
  const selectedReport = useSelector(selectSelectedReport);

  const tabs = [{ title: 'Info', content: <ReportInfo /> }];

  return (
    <>
      <div className="report-drawer-body">
        <TabLayout tabs={tabs} keyName="report-drawer" />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default ReportDrawerBody;
